import React from 'react'
import {scheduledReportType} from './model'
import {tableHeaderStyles} from './tableHeaderStyles'

type TableDataProps = {
  tableData: scheduledReportType[]
}

const ScheduledTableData = ({tableData}: TableDataProps) => {
  return (
    <div className='mt-4' style={{overflowY: 'auto', maxHeight: '20rem'}}>
      <table
        className='mt-4'
        style={{
          borderCollapse: 'separate',
          borderSpacing: '0',
          fontFamily: 'arial, sans-serif',
          width: '100%',
        }}
        table-layout={'table-layout:auto'}
      >
        <thead>
          <tr
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
              backgroundColor: '#343a40',
              color: '#fff',
            }}
          >
            {tableHeaderStyles.map(({label, style}, index) => (
              <th key={`${label}-${index}`} style={style}>
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index} style={{textAlign: 'center'}}>
              <td
                style={{
                  padding: '0.5rem',
                  border: '0.5px solid lightGray',
                  fontSize: '1.1rem',
                }}
              >
                {row.shift}
              </td>
              <td
                style={{
                  padding: '0.5rem',
                  border: '0.5px solid lightGray',
                  fontSize: '1.1rem',
                }}
              >
                {row.checkpoints}
              </td>
              <td
                style={{
                  padding: '0.5rem',
                  border: '0.5px solid lightGray',
                  fontSize: '1.1rem',
                }}
              >
                {row.expectedScans}
              </td>
              <td
                style={{
                  padding: '0.5rem',
                  border: '0.5px solid lightGray',
                  fontSize: '1.1rem',
                  backgroundColor: '#01AF4E',
                  color: '#fff',
                }}
              >
                {row.successfulScans}
              </td>
              <td
                style={{
                  padding: '0.5rem',
                  border: '0.5px solid lightGray',
                  borderLeft: 'none',
                  fontSize: '1.1rem',
                  backgroundColor: '#BE0201',
                  color: '#fff',
                }}
              >
                {row.missedScans}
              </td>
              <td
                style={{
                  padding: '0.5rem',
                  border: '0.5px solid lightGray',
                  fontSize: '1.1rem',
                }}
              >
                {row.successScanPercentage}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default ScheduledTableData
